// src/components/general-task/GeneralTaskIndex.tsx
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { GeneralTaskForm } from './GeneralTaskForm';
import  GeneralTaskList  from './GeneralTaskList';
import { GeneralTaskDashboard } from './GeneralTaskDashboard';
import AboutSection from '../AboutSection'; // Adjust path if needed

const isAdmin = true; // TODO: Replace with real auth check

const GeneralTaskFormWrapper: React.FC = () => {
  const location = useLocation();
  const pathname = location.pathname;

  let mode: 'create' | 'edit' | 'view' = 'view';
  if (pathname.endsWith('/create')) mode = 'create';
  else if (pathname.endsWith('/edit')) mode = 'edit';

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col w-full p-2">
      <AboutSection title={`General Tasks - ${mode}`} iconName="clipboard-list" />
      <GeneralTaskForm mode={mode} />
    </div>
  );
};

const GeneralTaskModule: React.FC = () => {
  if (!isAdmin) return <Navigate to="/unauthorized" />;

  return (
    <Routes>
      <Route index element={<GeneralTaskDashboard />} />
      <Route path="dashboard" element={<GeneralTaskDashboard />} />
      <Route path="list" element={<GeneralTaskList />} />
      <Route path="create" element={<GeneralTaskFormWrapper />} />
      <Route path=":id" element={<GeneralTaskFormWrapper />} />
      <Route path=":id/edit" element={<GeneralTaskFormWrapper />} />
    </Routes>
  );
};

export default GeneralTaskModule;